import { fromJS } from 'immutable';

import { combineReducerArray } from 'reducers/utils/helpers';

import fundingEnquiryListReducer from './list/reducer';
import fundingEnquiryUpdateStatusReducer from './updateStatus/reducer';

export * from './actions';

const initialState = fromJS({
  byId: {},
  list: {
    ids: [],
    network: {
      error: false,
      loading: false,
    },
  },
  updateStatus: {
    network: {
      error: false,
      loading: false,
    },
  },
});

export default combineReducerArray(initialState, [
  fundingEnquiryListReducer,
  fundingEnquiryUpdateStatusReducer,
]);
